export const getRetributionValue = (valor, lineal) =>
  (lineal && 'Lineal') || (valor > 0 ? valor : 'Sin retribución')
